import { Component, type ReactNode } from 'react';
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed)
      return (
        <div className="callback-page" role="alert">
          <h1>This page could not load.</h1>
          <p>Your saved account data is unchanged. Reload to try again.</p>
          <button className="btn-primary" onClick={() => window.location.reload()}>
            Reload application
          </button>
        </div>
      );
    return this.props.children;
  }
}
